<template>
  <div>
    <b-form v-on:submit.prevent="submit()" validated novalidateenc type="multipart/form-data">
      <b-form-group label-for="Name" label="Name">
        <b-form-input type="text" v-model="survey.name" class="form-control-warning" id="Name" required></b-form-input>
          <b-form-valid-feedback>
            Valid name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter survey name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Delay" label="Delay">
          <b-form-input type="number" v-model.number="survey.delay" class="form-control-warning" style="width: 80px;" id="Delay" required></b-form-input>
          <b-form-valid-feedback>
            Valid delay provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter survey delay.
          </b-form-invalid-feedback>
        </b-form-group>
        <Allocation :adForm="survey" :hideCompany="hideCompany" :isEdit="surveyIsEdit"></Allocation>
        <div class="float-right">
          <a href="#" @click.prevent="noExpiry(survey)">No expiry</a>
        </div>
        <b-form-group label-for="ExpiryDate" label="Expiry Date">
          <datepicker v-model="survey.expiryDate" name="ExpiryDate" :input-class="'form-control input-cal'"></datepicker>
        </b-form-group>
        <b-form-checkbox v-model="survey.enabled">Enabled</b-form-checkbox>
        <div class="mt-4 text-right">
          <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> {{btnText}}</b-button>
          <router-link class="btn btn-success btn-sm" :to="{ path: '/surveys/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
        </div>
      </b-form>
    </div>
</template>
<script>
import Allocation from '@/views/admin/Allocation'
import Datepicker from 'vuejs-datepicker'
import common from './../../mixins/common'

export default {
  name: 'survey',
  props: ['survey'],
  components: {
    Allocation,
    Datepicker
  },
  mixins: [common],
  computed: {
    btnText () {
      return (this.$store.getters.surveyIsEdit ? 'Save':'Add');
    }
  },
  methods: {
    submit () {
      let scope = this;
      if(!scope.survey.name) {
        console.log('invalid')
        return
      }
      if(!scope.survey.delay) {
        console.log('invalid')
        return
      }
      if(!scope.survey.company) {
        console.log('invalid')
        return
      }

      scope.survey.expiryDate = scope.prepareDate(scope.survey.expiryDate);

      this.$store.commit('updateQuestion', {});
      this.$store.commit('updateQuestionIsEdit', false);

      if(this.surveyIsEdit) {
        this.$store.dispatch('updateSurvey', scope.survey).then(result => {
          this.$store.dispatch('getSurvey', scope.survey._id).then(result2 => {
            this.$store.commit('updateSurveyMode', 'step-question');
          }, error2 => {
            console.log(error);  
          });
        }, error => {
          console.log(error);
        });
      } else {
        scope.survey.user = scope.$store.getters.currentUser.id;
        scope.survey.impressions = 0;
        scope.survey.starts = 0;
        scope.survey.completes = 0;
        scope.survey.enabled = false;
        this.$store.dispatch('addSurvey', scope.survey).then(result => {
          this.$store.commit('updateSurveyMode', 'step-question');
        }, error => {
          console.log(error);
        });
      }
    }
  }
}
</script>
